
import translator from '@Components/Utilities/Translator';

const StaticACCReport = ({ ACCUrl }) => {
    return (
        <div className='acc-container'>
            <div className='acc-top cf'>
                <div className='column6 left'>
                    <img src='/Content/Controller/images/acc/acc_logo.png' alt='Aircraft Cost Calculator' loading='lazy' />
                </div>
                <div className='column6 left'>
                    <a className='ts-button btn' href={ACCUrl} target='_blank' aria-label={"Click Here to find your Operating Cost (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                        <strong>Click Here to find your Operating Cost </strong>
                    </a>
                </div>
            </div>
            <div className='acc-mid cf'>
                <div className='column6 left'>
                    <img src='/Content/Controller/images/acc/acc_summary.png' alt='Aircraft Cost Calculator Summary' loading='lazy' />
                </div>
                <div className='column6 left'>
                    <h2>Aviation’s Most Powerful Operating Cost Analytics Tool In A Single App</h2>
                    Aircraft Cost Calculator enables users to determine the true operating costs of <strong>500+ aircraft and helicopters</strong> in our database.
        </div>
            </div>
            <div className='acc-bottom cf'>
                <div className='column6 left'>
                    <h3>Get Aircraft Operating Cost Reports Now</h3>
                    <ul>
                        <li>Detailed Aircraft Information</li>
                        <li>Aircraft Performance Data</li>
                        <li>Payment Schedule</li>
                        <li>Annual Fixed Costs</li>
                        <li>Annual Variable Costs</li>
                        <li>Hourly Cost Analysis</li>
                        <li>Annual / Monthly Budgets</li>
                    </ul>
                </div>
                <div className='column6 left'>
                    <img src='/Content/Controller/images/acc/acc_report.png' alt='Aircraft Cost Calculator Report' loading='lazy' />
                </div>
            </div>
        </div>
    );
};

export default StaticACCReport;